import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractSpecificDataComponent } from '../../abstract-specific-data.component';

@Component({
  selector: 'app-specific-data-conf29',
  templateUrl: './specific-data-conf29.component.html',
  styleUrls: ['../specific-data-conf.common.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SpecificDataConf29Component extends AbstractSpecificDataComponent {
  @Input() override touchNonce?: number;

  override getDataName(): string {
    return 'specific-data-conf29';
  }
}
